import React, { useState } from "react";
import { useAuth } from "../contexts/AuthContext";
import { supabase } from "../lib/supabase";

export default function ChooseUsernameModal() {
  const { user, profile, profileLoaded, refreshProfile, signOut } = useAuth();
  const [username, setUsername] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  // Only when a signed-in user's profile is loaded and has no username.
  if (!user || !profileLoaded || profile?.username) return null;

  const submit = async (e) => {
    e.preventDefault();
    if (!/^[a-zA-Z0-9_-]{3,20}$/.test(username)) {
      setError("3–20 chars: letters, numbers, underscore, hyphen.");
      return;
    }
    setBusy(true);
    setError(null);
    const { error } = await supabase
      .from("profiles")
      .update({ username })
      .eq("id", user.id);
    if (error) {
      setError(
        error.code === "23505" ? "Username already taken" : error.message,
      );
      setBusy(false);
      return;
    }
    await refreshProfile();
    setBusy(false);
  };

  return (
    <div className="fixed inset-0 z-[90] bg-black/70 backdrop-blur-sm grid place-items-center p-6">
      <form
        onSubmit={submit}
        className="bg-zinc-950 border border-zinc-800 rounded-2xl w-full max-w-sm
                   p-6 animate-scale-in shadow-2xl shadow-black/50"
      >
        <h3 className="text-lg font-bold text-zinc-100">Choose a username</h3>
        <p className="text-xs text-zinc-500 mt-1">
          This is how you'll appear on the leaderboards.
        </p>

        <input
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          maxLength={20}
          placeholder="username"
          className="mt-4 w-full bg-zinc-900 border border-zinc-800 rounded-lg
                     px-3 py-2 text-sm text-zinc-100 placeholder:text-zinc-600
                     focus:outline-none focus:border-zinc-700 transition"
        />

        {error && (
          <div className="mt-3 text-xs text-red-300 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2">
            {error}
          </div>
        )}

        <button
          type="submit"
          disabled={busy}
          className="mt-5 w-full py-2.5 rounded-full bg-emerald-500 text-zinc-950
                     font-semibold text-sm hover:bg-emerald-400 transition disabled:opacity-50"
        >
          {busy ? "…" : "Continue"}
        </button>

        <button
          type="button"
          onClick={signOut}
          className="mt-3 w-full text-center text-xs text-zinc-500 hover:text-zinc-300 transition"
        >
          Cancel and sign out
        </button>
      </form>
    </div>
  );
}
